import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BannerPopupService {
  public isOpen: boolean = false;
  public imageURL: string = null;
  public onCloseCallback: () => void = null;
  public onClickCallback: () => void = null;

  public open(options: { image: string, onClose?: () => any, onClick?: () => any } = null) {
    this.imageURL = options.image;
    this.onCloseCallback = options?.onClose || null;
    this.onClickCallback = options?.onClick || null;
    this.isOpen = true;
  }

  public close() {
    if(this.onCloseCallback !== null)
      this.onCloseCallback();

    this.onCloseCallback = null;
    this.onCloseCallback = null;
    this.isOpen = false;
  }
}
